import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategoryCards() {
  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
            赛事分类
          </h2>
          <p className="text-foreground-500 text-sm mt-2">选择您感兴趣的体育项目，获取专属赛事资讯</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group relative bg-background-50 rounded-lg overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-200 cursor-pointer"
            >
              <div className="aspect-[4/3] overflow-hidden">
                <img
                  src={cat.image}
                  alt={cat.name}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500 object-top"
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-4">
                <div className="flex items-center gap-2 mb-1">
                  <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500/80">
                    <i className={`${cat.icon} text-sm text-background-50`}></i>
                  </div>
                  <h3 className="font-heading text-lg font-semibold text-background-50">
                    {cat.name}
                  </h3>
                </div>
                <p className="text-background-200 text-xs line-clamp-2">
                  {cat.description}
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}